import {Box} from '@mui/material';
type Props = {
  color?: string;
  size?: number;
};
export default (props: Props) => {
  return (
    <Box
      sx={{
        p: 0.8,
        borderRadius: '100%',
        width: 'min-content',
        height: 'min-content',
        border: `solid 2px ${props.color ?? '#fff'}`,
      }}
    >
      <Box
        sx={{
          width: `${props.size ?? 65}px`,
          height: `${props.size ?? 65}px`,
          borderRadius: '100%',
          backgroundColor: props.color ?? '#fff',
        }}
      ></Box>
    </Box>
  );
};
